// extracted by mini-css-extract-plugin
export default {"container":"TRUiiWKzLhTw88Eqt1Xi","infoIcon":"nbh8tyxkw2mgo1B2UE9E","content":"DpuLePxdjHIM3f12DkZl","title":"SFiDQM2qoXHrgOq2kA0w","description":"qFR_6Ti6G3WkoruisJfB"};